export const WeekDays = {
    'mon':[ { "from":"07:00", "to":"11:00" }, { "from":"12:00", "to":"18:00" } ],
    'tue':[ { "from":"07:00", "to":"11:00" }, { "from":"12:00", "to":"18:00" } ],
    'wed':[ { "from":"07:00", "to":"11:00" }, { "from":"12:00", "to":"18:00" } ],
    'thu':[ { "from":"07:00", "to":"11:00" }, { "from":"12:00", "to":"18:00" } ],
    'fri':[ { "from":"07:00", "to":"11:00" }, { "from":"12:00", "to":"18:00" } ],
    'sat':[ { "from":"11:00", "to":"13:00" }, { "from":"13:30", "to":"17:00" } ],
    'sun':[ { "from":"10:00", "to":"13:00" }, { "from":"13:30", "to":"17:00" } ]
};

export const defaultDaysOff = {
    'mon': false,
    'tue': false,
    'wed': false,
    'thu': false,
    'fri': false,
    'sat': false,
    'sun': false
};

export const defaultLunchBreak = {
    'mon': true,
    'tue': true,
    'wed': true,
    'thu': true,
    'fri': true,
    'sat': true,
    'sun': true
};

export const defaultDayHours = ["07:00", "11:00", "12:00", "18:00" ];

export const defaultWeekDay = [ { "from":"07:00", "to":"11:00" }, { "from":"12:00", "to":"18:00" } ];

export const defaultWeekDayNoLunchBeak = [ { "from":"07:00", "to":"18:00" } ];

export const hiddenHoursLunchBreak = { "from":"12:00", "to":"18:00" };

export const defaultSpecialDate = {
    name: '',
    date: null,
    workTime: [ { "from":"11:00", "to":"13:00" }, { "from":"13:30", "to":"17:00" } ],
    lunchBreak: true,
    dayOff: false,
    error: ''
};

export const defaultSpecialWorkTime = [ { "from":"11:00", "to":"13:00" }, { "from":"13:30", "to":"17:00" } ];


// WEBPACK FOOTER //
// ./src/customModules/Common/work-time-pharmacy/weekdays.js